import { Link } from 'react-router';
import { EmptyState, PageLayout, Panel } from '../components/ui';

export function NotFoundPage() {
  return (
    <PageLayout
      main={
        <Panel title="Not found" meta="404">
          <EmptyState>
            Nothing lives at this address. <Link to="/">Back to Tonight</Link>
          </EmptyState>
        </Panel>
      }
    />
  );
}
